import { useState } from 'react';

import BranchPicker from '@/shared/dev/components/BranchPicker';
import type { Option } from '@/shared/dev/types/types';

import Cookies from 'js-cookie';

type Props = {
  label: string;
  onBranchChanged: () => void;
};

const ProjectID = 3;
const EnvironmentIDs = [70];
const CookieName = 'X-App-Branch';

export default function ReactBranches({ label, onBranchChanged }: Props) {
  // @ts-ignore
  const [currentBranch, setCurrentBranch] = useState<string>(Cookies.get(CookieName, { domain: CONFIG.COOKIE_DOMAIN }));

  const changeBranch = (branch: Option) => {
    if (branch === null) {
      Cookies.remove(CookieName, { domain: CONFIG.COOKIE_DOMAIN });
      setCurrentBranch('<Default>');
      onBranchChanged();
    }
    if (!branch) {
      return;
    }

    Cookies.set(CookieName, branch.value, { domain: CONFIG.COOKIE_DOMAIN });
    setCurrentBranch(branch.value);
    onBranchChanged();
  };

  return (
    <BranchPicker
      label={label}
      projectId={ProjectID}
      environmentIds={EnvironmentIDs}
      currentBranch={currentBranch}
      changeBranch={changeBranch}
      branchLink={
        <a
          href={encodeURI(`https://appx.wheniwork.net/cmd/choose?branch=${currentBranch}&redirect=/`)}
          className="mb-1"
        >
          Link to branch
        </a>
      }
    />
  );
}
